import { useState } from "react";

/**
 * Manages a per-key cycling index (e.g. for rotating through unit representations).
 * Returns [indices, cycle] where cycle(id, count) advances the index for that id.
 */
export function useCyclingIndex(): [Record<string, number>, (id: string, count: number) => void] {
  const [indices, setIndices] = useState<Record<string, number>>({});

  function cycle(id: string, count: number) {
    setIndices((prev) => ({ ...prev, [id]: ((prev[id] ?? 0) + 1) % count }));
  }

  return [indices, cycle];
}
